<!-- 永欣计件工资报表 -->
<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/yongxin/pieceWages/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <!-- 工单实际开始时间 -->
          <el-form-item :label="$t('gongdanshijikaishishijian')">
            <yi_time_input type="daterange" :format="'yyyy-MM-dd'" :start.sync="yt.conditions.actualStartTime" :end.sync="yt.conditions.actualEndTime"> </yi_time_input>
          </el-form-item>
          <!-- 部门 -->
          <!-- <el-form-item :label="$t('bumen')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.orgId"> </yi_data_select>
          </el-form-item> -->
          <!-- 生产工单号 -->
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <!-- 产品名称 -->
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_cross_select multiple :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialIds"> </yi_cross_select>
          </el-form-item>
          <!-- 工序描述 -->
          <el-form-item :label="$t('gongxumiaoshu')">
            <yi_data_select multiple :type="'work_procedure'" :ids.sync="yt.conditions.workProcedureIds"> </yi_data_select>
            <!-- <yi_cross_select multiple :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="yt.conditions.procedureId"> </yi_cross_select> -->
          </el-form-item>
          <!-- 作业者 -->
          <el-form-item :label="$t('zuoyezhe')">
            <yi_data_select multiple :type="'customer_user'" :ids.sync="yt.conditions.operators"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1, null)" type="primary" plain>
              {{ $t("sousuo") }}
            </el-button>
            <el-button
              @click="
                yt.clear(
                  {
                    actualStartTime: dayjs()
                      .startOf('month')
                      .valueOf(),
                      actualEndTime: dayjs()
                      .endOf('month')
                      .valueOf(),
                  },
                  null
                )
              "
            >
              {{ $t("chongzhi") }}
            </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button v-if="utils.checkPower('web_report_piece_rate_report_yongxin_export')" size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #footer>
        <!-- 这里可以在底部填写东西 -->
        <div style="display: flex;flex-wrap: nowrap;justify-content: flex-start;align-items: center;">
          
        </div>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_report_piece_rate_report_yongxin",

  data() {
    return {
      exportLoading: false,
      list: [],
      totalExtend: {},
      columns: [
        {
          label: "shengchangongdanhao",
          prop: "woNo",
          width: 200,
        },
        {
          label: "gongdanshijikaishishijian",
          prop: "actualStartTime",
          type: "time",
          width: 180,
        },
        {
          label: "bumen",
          prop: "department",
          width: 130,
        },
        {
          label: "zuoyezhe",
          prop: "operatorName",
          width: 130,
        },
        {
          label: "chanpinbianma",
          prop: "material.code",
          width: 130,
        },
        {
          label: "chanpinmingcheng",
          prop: "material.name",
          width: 130,
        },
        {
          label: "guige",
          prop: "material.spec",
          width: 130,
        },
        {
          label: "caizhi",
          prop: "material.ingredient",
          width: 130,
        },
        {
          label: "yanse",
          prop: "material.color",
          width: 130,
        },
        {
          label: "gongxumiaoshu",
          prop: "workProcedureDesc",
          width: 130,
        },
        {
          label: "yibaogongliangpinshu",
          prop: "goodQuantity",
          width: 130,
        },
        {
          label: "danjia",
          prop: "price",
          width: 130,
        },
        {
          label: "jine",
          prop: "amount",
          width: 130,
        },
        {
          label: "beizhu",
          prop: "remark",
          width: 130,
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      // this.yt.conditions.actualStartDateStart = this.dayjs()
      //   .startOf("month")
      //   .valueOf();
      //   this.yt.conditions.actualStartDateEnd = this.dayjs()
      //   .endOf("month")
      //   .valueOf();
        this.yt.conditions.actualStartTime = this.dayjs()
        .startOf("month")
        .valueOf();
        this.yt.conditions.actualEndTime = this.dayjs()
        .endOf("month")
        .valueOf();
      this.yt.get(1);
    }, 300);
  },
  methods: {
    exportExcel() {
      this.exportLoading = true;
      let params = this.yt.conditions;
      return this.http
        .get("/web/report/export/piece_rate_report_yongxin", {
          params,
        })
        .then((res) => {
          this.exportLoading = false;
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
          this.exportLoading = false;
        });
    },
    // 重置
    // clear() {
    // 	this.yt.conditions = {
    // 		actualStartTime: this.dayjs()
    //     .startOf("month")
    //     .valueOf(),
    // 		actualEndTime: this.dayjs()
    //     .endOf("month")
    //     .valueOf()
    
    // 	}
    // 	this.yt.list = []
    // },
  },
};
</script>
